import React from "react";

export default function BridgeStart() {
  return (
    <img src="/assets/odontogram/bridge-start.svg" alt="brigde-start"></img>
  );
}
